import { ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
    ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS,
    ESTACIO_INTRODUCCIO_FOTOS_CREAR_FOTO,
    ESTACIO_INTRODUCCIO_FOTOS_ELIMINAR_FOTO,
    ESTACIO_INTRODUCCIO_FOTOS_DESCARTAR_FOTO } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = {
    originals: [],
    eliminades: [],
    creades: []
};

const fotos = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES:
            return {
                originals: action.estructuraIDades.dades.fotos,
                eliminades: [],
                creades: []
            };

        case ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS:
            return {
                originals: state.originals,
                eliminades: [],
                creades: []
            };

        case ESTACIO_INTRODUCCIO_FOTOS_CREAR_FOTO:
            return {
                ...state,
                creades: [...state.creades, action.foto]
            };

        case ESTACIO_INTRODUCCIO_FOTOS_ELIMINAR_FOTO:
            return {
                ...state,
                eliminades: [...state.eliminades, action.foto]
            };

        case ESTACIO_INTRODUCCIO_FOTOS_DESCARTAR_FOTO:
            return {
                ...state,
                creades:
                    [
                        ...state.creades.slice(0,action.indexFoto),
                        ...state.creades.slice(action.indexFoto+1)
                    ]
            };

        default:
            return state;
    }
};

export default fotos;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/dades/fotos.js